module.exports = __webpack_public_path__ + "img/warning.4e5297fd.svg";